import React from 'react';
import classes from '../SlotContent/slotContent.module.scss';
import cn from 'classnames';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const SlotFooter = ({
  check,
  setSelectedCheck,
  handleExpandedRightSection,
  pickedUp,
}) => {
  const isPickedUp = check?.status?.status === 'Picked Up';
  return (
    <div
      className={cn(
        'row mx-0 pb-2 px-0 h-20 align-items-end',
        classes.slotFooter
      )}
    >
      <div className="col-6 pl-2 pr-1 h-100">
        <button className={cn(classes.actionButton, 'col-12 px-2')}>
          <span
            className={classes.buttonText}
            onClick={() => {
              handleExpandedRightSection('notifyGuest');
              setSelectedCheck(check.id);
            }}
          >
            {FLABEL().CHECK_NOTIFY}
          </span>
        </button>
      </div>
      <div className="col-6 pl-1 pr-2 h-100">
        <button
          className={cn(
            classes.actionButton,
            'col-12 px-2',
            isPickedUp && classes.disabledbtn
          )}
          disabled={isPickedUp}
          onClick={() => {
            pickedUp(check, 'pickedUp');
          }}
        >
          <span className={classes.buttonText}>{FLABEL().CHECK_PICKUP}</span>
        </button>
      </div>
    </div>
  );
};

export default SlotFooter;
